<body>
  
    
  <block-ui message="Loading" style="color: black; ">
    <app-header></app-header>
    <section class="block-form">
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </section>
  </block-ui>
</body>